exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notifications-box[data-v-50871d0c]{position:absolute;right:10%}@media screen and (min-width:1920px){.notifications-box[data-v-50871d0c]{right:0}}", ""]);

// exports
